export class UsuarioLdap {
    txt_nome: string;
    txt_email: string;
    num_cpf: string;
    txt_cargo: string;
    txt_orgao: string;
    num_telefone: number;
    txt_unidade: string;
    txt_situacao: any;
}
